/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetPackagedCustomerOrdersByOrderPackageID(orderPackageID) {
  const response = await $.soap({
    body: {
      GetPackagedCustomerOrdersByOrderPackageID: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        OrderPackageID: orderPackageID
      }
    },
    blueprintArrays: ['GetPackagedCustomerOrdersByOrderPackageIDResponse.tuple'],
    blueprint: {
      orders: [
        'GetPackagedCustomerOrdersByOrderPackageIDResponse.tuple',
        {
          id: '$..ID',
          orderFormTypeID: '$..OrderFormTypeID',
          formCode: '$..FormCode',
          formName: '$..FormName',
          statusID: '$..StatusID',
          status: '$..InternalOrderStatus',
          deviceCount: '$..DeviceCount',
          submittedOn: '$..SubmittedOn',
          approvedOn: '$..ApprovedOn',
          expectedDeliveryDate: '$..ExpectedDeliveryDate',
          popStartDate: '$..POPDate',
          replacementPIINSPIIN: '$..ReplacementPIINSPIIN',
          trackerNumber: '$..TrackerNumber',
          CommandID: '$..CommandID'
        }
      ]
    }
  });
  cleanUpResponse(response);
  return response.orders;
}
